export default __webpack_public_path__ + "static/media/stripe.81995af2.png";